import { useEffect } from "react";

export default function useComponentDidMount(onMount) {
  // biome-ignore lint/correctness/useExhaustiveDependencies: intentionally runs only on mount
  useEffect(onMount, []);
}
